module.exports = __webpack_public_path__ + "public/downArrow.svg?2701d394";